import { Extension } from '@tiptap/react';

/**
 *
 * Extension that adds floating menu specification metadata to node schemas.
 * This extension automatically determines whether nodes should display a floating menu.
 *
 */
export const ZyFloatingMenuSpec = Extension.create({
    name: 'zyFloatingMenu',

    extendNodeSchema(extension) {
        let showFloatingMenu = false;
        const otherZyExtensions = [
            'questionSet',
            'testQuestion',
            'progressionBuilder',
            'imageUpload',
            'blockOrderingBuilder',
            'codeWritingBuilder',
            'codeOutputBuilder',
            'openStaxPythonCodeRunnerBuilder',
            'parsonsCodingBuilder',
            'iframe',
            'image',
        ];

        if (extension.name.startsWith('zy') || otherZyExtensions.includes(extension.name)) {
            showFloatingMenu = true;
        }

        if (extension.name.startsWith('zyITLab') && extension.name !== 'zyITLab') {
            showFloatingMenu = false;
        }
        return { showFloatingMenu };
    },
});
